export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更預告_en-539ca7b37eedec37f3f0937180a2cb2d.png";